import NeighborhoodPage from "@/components/NeighborhoodPage";
import heroImage from "@/assets/hero-copacabana-beach.jpg?w=640;1024;1600;1920&format=avif;webp;jpg&as=picture";

const Copacabana = () => (
  <NeighborhoodPage
    name="Copacabana"
    slug="copacabana"
    description="Um dos bairros mais icônicos do mundo, com orla deslumbrante, vida cultural vibrante e imóveis com vista para o mar."
    heroPicture={heroImage}
  />
);

export default Copacabana;
